import {
  Box,
  Button,
  Card,
  CardActionArea,
  CardContent,
  Chip,
  Grid,
  Stack,
  Typography,
} from '@mui/material';
import CampaignIcon from '@mui/icons-material/Campaign';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import changelog from '../data/changelog';

const latestNotice = changelog?.[0];

function Home() {
  return (
    <>
      <Helmet>
        <title>POE Regex KR - 패스 오브 엑자일 정규식 생성기</title>
        <meta
          name="description"
          content="패스 오브 엑자일(POE1/POE2) 지도 모드, 아이템 필터용 한글 정규식을 손쉽게 생성하는 사이트입니다. 지도 정규식, 결전, 항해, 시세 정보, 도전과제 공략 등 다양한 도구를 제공합니다."
        />
        <meta property="og:title" content="POE Regex KR" />
        <meta
          property="og:description"
          content="패스 오브 엑자일(POE1/POE2) 정규식 생성기 모음. 지도, 결전, 항해, 경로석 정규식과 시세 정보를 제공합니다."
        />
        <meta property="og:url" content="https://poeregexkr.web.app/" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://poeregexkr.web.app/mirror.png" />
      </Helmet>

      <Box sx={{ textAlign: 'center', pt: { xs: 5, md: 9 }, pb: { xs: 4, md: 6 } }}>
        <Box
          component="img"
          src={process.env.PUBLIC_URL + '/mirror.png'}
          alt=""
          sx={{ width: 56, height: 56, mb: 2 }}
        />
        <Typography
          variant="h3"
          sx={{ fontWeight: 800, letterSpacing: '.05rem', fontSize: { xs: 30, sm: 38, md: 46 } }}
        >
          POE Regex KR
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mt: 1.5, maxWidth: 560, mx: 'auto' }}>
          패스 오브 엑자일 지도 모드 · 아이템 필터용 정규식을 몇 번의 클릭으로 생성하세요.
        </Typography>
      </Box>

      {latestNotice && (
        <Card
          sx={{
            mb: 4,
            borderColor: 'rgba(249,168,37,0.4)',
            bgcolor: 'rgba(249,168,37,0.08)',
          }}
        >
          <CardContent>
            <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
              <CampaignIcon color="warning" fontSize="small" />
              <Typography variant="subtitle2" sx={{ fontWeight: 700, color: 'warning.main' }}>
                공지사항 · {latestNotice.date}
              </Typography>
            </Stack>
            <Stack spacing={0.5}>
              {latestNotice.changes.map((change, i) => (
                <Typography key={i} variant="body2" color="text.secondary">
                  {change}
                </Typography>
              ))}
            </Stack>
            <Button component={Link} to="/update" size="small" endIcon={<ArrowForwardIcon />} sx={{ mt: 1.5 }}>
              전체 변경사항 보기
            </Button>
          </CardContent>
        </Card>
      )}

      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <Card sx={{ height: '100%' }}>
            <CardActionArea component={Link} to="/map" sx={{ height: '100%', p: 3 }}>
              <Stack spacing={1.5}>
                <Box
                  component="img"
                  src={process.env.PUBLIC_URL + '/images/poe1logo.webp'}
                  alt="POE1"
                  sx={{ width: 80, height: 80, objectFit: 'contain' }}
                />
                <Typography variant="h6">POE1 바로가기</Typography>
                <Typography variant="body2" color="text.secondary">
                  지도 · 결전 · 항해 정규식 생성, 갑충석 · 야수 · 문신 · 룬 · 성유 시세, 도전과제 공략까지
                </Typography>
                <Chip label="지도 정규식 생성기" size="small" sx={{ alignSelf: 'flex-start' }} />
              </Stack>
            </CardActionArea>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Card sx={{ height: '100%' }}>
            <CardActionArea component={Link} to="/poe2/map" sx={{ height: '100%', p: 3 }}>
              <Stack spacing={1.5}>
                <Box
                  component="img"
                  src={process.env.PUBLIC_URL + '/images/poe2logo.webp'}
                  alt="POE2"
                  sx={{ width: 80, height: 80, objectFit: 'contain' }}
                />
                <Typography variant="h6">POE2 바로가기</Typography>
                <Typography variant="body2" color="text.secondary">
                  경로석(Waystone) · 서판(Tablet) 정규식 검색 및 저장 목록 관리
                </Typography>
                <Chip label="경로석 정규식 검색" size="small" sx={{ alignSelf: 'flex-start' }} />
              </Stack>
            </CardActionArea>
          </Card>
        </Grid>
      </Grid>

      <Box sx={{ textAlign: 'center', pt: 4, pb: 6 }}>
        <Typography variant="body2" color="text.secondary">
          사용 중 오류를 발견하셨나요?{' '}
          <Link to="/bugreport" style={{ color: 'inherit', fontWeight: 700 }}>
            버그 제보 페이지
          </Link>
          에서 알려주세요.
        </Typography>
      </Box>
    </>
  );
}

export default Home;
